import dayjs from 'dayjs';

export const formatTimeSlots = (slots: string[]) => {
  // Sort the time slots by date and time
  const sortedSlots = slots?.sort((slotA, slotB) => {
    const [slotAStart] = slotA.split(',');
    const [slotBStart] = slotB.split(',');
    return dayjs(slotAStart).isAfter(dayjs(slotBStart)) ? 1 : -1;
  });

  // Format the sorted time slots
  return sortedSlots
    ?.map((slot) => {
      const [slotStartsFrom] = slot.split(',');
      const slotParsedDate = dayjs(slotStartsFrom);

      const formattedTime = slotParsedDate.format('hh:mm A ddd DD/MM/YYYY');
      const formattedTimeTodayAndTomorrow = slotParsedDate.format('hh:mm A');

      const today = dayjs().startOf('day');
      const slotDay = slotParsedDate.startOf('day');
      const dayDiff = slotDay.diff(today, 'day', true);

      if (dayDiff === 1) {
        return `${formattedTimeTodayAndTomorrow} Tomorrow`;
      } else if (dayDiff === 0) {
        return `${formattedTimeTodayAndTomorrow}`;
      } else {
        return `${formattedTime} `;
      }
    })
    .join(', ');
};

export const formatTimeSlot = (slot: string) =>
  `${dayjs(slot.split(',')[0]).format('hh:mm A')} - ${dayjs(slot.split(',')[1]).format('hh:mm A')}`;

export const isSameSlot = (slotA: string, slotB: string) => {
  const [slotAStart, slotAEnd] = slotA.split(',');
  const [slotBStart, slotBEnd] = slotB.split(',');

  return (
    dayjs(slotAStart).format('D-M-YYYY H:m') + dayjs(slotAEnd).format('D-M-YYYY H:m') ===
    dayjs(slotBStart).format('D-M-YYYY H:m') + dayjs(slotBEnd).format('D-M-YYYY H:m')
  );
};

export const formatDate = (date: string) => {
  const parsedDate = dayjs(date, 'DD/MM/YYYY');
  return dayjs().isSame(parsedDate, 'day') ? 'Today' : parsedDate.format('DD/MM/YYYY');
};

export const isOverDue = (endDate: string, endTime: string) => {
  const dueDateTimeString = `${endDate}T${endTime}`;

  const dueDateUTC = dayjs.utc(dueDateTimeString);

  const dueDateLocal = dueDateUTC.local();
  const now = dayjs();
  const oneHourBeforeDueDate = dueDateLocal.subtract(1, 'hour');
  const hoursDifference = oneHourBeforeDueDate.diff(now, 'hour');

  if (hoursDifference < 0) {
    return 'overDue';
  } else if (hoursDifference <= 0) {
    return 'dueSoon';
  } else {
    return 'haveTime';
  }
};
